/* NEW: UI_REVAMP */
import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';

const EmptyState = ({ label = 'No Data', minHeight = { base: '50vh', lg: '360px' } }) => {
	return (
		<Flex
			flex='1'
			width='100%'
			minHeight={minHeight}
			flexDirection='column'
			justifyContent='center'
			alignItems='center'
			gap='12px'
		>
			<Flex
				position='relative'
				justifyContent='center'
				alignItems='center'
				width='84px'
				height='84px'
				aria-hidden='true'
			>
				<Flex
					position='relative'
					justifyContent='center'
					alignItems='center'
					width='55.8px'
					height='55.8px'
					borderRadius='20px'
					background='linear-gradient(180deg, #FFE5E5 0%, #FFD2D2 100%)'
					border='1.5px solid #FF9FA6'
					boxShadow='0 4px 8px rgba(239, 55, 57, 0.24)'
				>
					<Flex
						position='relative'
						justifyContent='center'
						alignItems='center'
						width='35.8px'
						height='35.8px'
						borderRadius='50%'
						background='linear-gradient(180deg, #FF8C8B 0%, #EF3739 48%, #EF3739 100%)'
						boxShadow='0 6px 10px rgba(239, 55, 57, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.45)'
					>
						<Box
							position='absolute'
							width='24.85px'
							height='4px'
							top='50%'
							left='50%'
							borderRadius='4px'
							backgroundColor='white'
							transform='translate(-50%, -50%) rotate(45deg)'
						/>
						<Box
							position='absolute'
							width='24.85px'
							height='4px'
							top='50%'
							left='50%'
							borderRadius='4px'
							backgroundColor='white'
							transform='translate(-50%, -50%) rotate(-45deg)'
						/>
					</Flex>
				</Flex>
			</Flex>
			<Text fontSize='24px' fontWeight='500' lineHeight='100%' color='#111111' textAlign='center'>
				{label}
			</Text>
		</Flex>
	);
};

export default EmptyState;
